import { render } from "./FootballPage.vue?vue&type=template&id=6fc38750&scoped=true"
import script from "./FootballPage.vue?vue&type=script&lang=js"
export * from "./FootballPage.vue?vue&type=script&lang=js"

import "./FootballPage.vue?vue&type=style&index=0&id=6fc38750&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc38750"]])

export default __exports__